"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InventoryOnHandFilter = exports.InventoryOnHandGroupBy = exports.InventoryOnHandProductsContract = exports.InventoryOnHandCategoriesContract = exports.InventoryUpdatedContract = exports.InventoryEventDataContract = void 0;
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const events_1 = require("@getgreenline/events");
const shared_1 = require("@getgreenline/shared");
class InventoryEventDataContract {
}
exports.InventoryEventDataContract = InventoryEventDataContract;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], InventoryEventDataContract.prototype, "productId", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsInt)(),
    __metadata("design:type", Number)
], InventoryEventDataContract.prototype, "oldQuantity", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsInt)(),
    __metadata("design:type", Number)
], InventoryEventDataContract.prototype, "quantity", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsInt)(),
    __metadata("design:type", Number)
], InventoryEventDataContract.prototype, "reStockQuantity", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsInt)(),
    __metadata("design:type", Number)
], InventoryEventDataContract.prototype, "lowStockQuantity", void 0);
class InventoryUpdatedContract extends events_1.EventContract {
    constructor(params) {
        super(params);
        this.inventory = events_1.GreenlineEvent.create(InventoryEventDataContract, params.inventory);
    }
}
exports.InventoryUpdatedContract = InventoryUpdatedContract;
class InventoryOnHandCategoriesContract {
}
exports.InventoryOnHandCategoriesContract = InventoryOnHandCategoriesContract;
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], InventoryOnHandCategoriesContract.prototype, "categoryName", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], InventoryOnHandCategoriesContract.prototype, "parentCategoryName", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsInt)(),
    __metadata("design:type", Number)
], InventoryOnHandCategoriesContract.prototype, "inventoryQuantity", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], InventoryOnHandCategoriesContract.prototype, "inventoryCost", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], InventoryOnHandCategoriesContract.prototype, "inventoryPrice", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], InventoryOnHandCategoriesContract.prototype, "margin", void 0);
class InventoryOnHandProductsContract extends InventoryOnHandCategoriesContract {
}
exports.InventoryOnHandProductsContract = InventoryOnHandProductsContract;
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], InventoryOnHandProductsContract.prototype, "locationName", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], InventoryOnHandProductsContract.prototype, "productName", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], InventoryOnHandProductsContract.prototype, "productSKU", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], InventoryOnHandProductsContract.prototype, "productVendorName", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], InventoryOnHandProductsContract.prototype, "productCost", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], InventoryOnHandProductsContract.prototype, "productPrice", void 0);
var InventoryOnHandGroupBy;
(function (InventoryOnHandGroupBy) {
    InventoryOnHandGroupBy["CATEGORIES"] = "categories";
    InventoryOnHandGroupBy["PRODUCTS"] = "products";
})(InventoryOnHandGroupBy || (exports.InventoryOnHandGroupBy = InventoryOnHandGroupBy = {}));
class InventoryOnHandFilter extends shared_1.Pagination {
}
exports.InventoryOnHandFilter = InventoryOnHandFilter;
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsEnum)(InventoryOnHandGroupBy, {
        message: `$property must be ${InventoryOnHandGroupBy.CATEGORIES} or ${InventoryOnHandGroupBy.PRODUCTS}, instead received $value`,
    }),
    __metadata("design:type", String)
], InventoryOnHandFilter.prototype, "groupBy", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsInt)({ each: true }),
    (0, class_transformer_1.Type)(() => Number),
    (0, class_transformer_1.Transform)(({ value }) => (Array.isArray(value) ? value : [value])),
    __metadata("design:type", Array)
], InventoryOnHandFilter.prototype, "locationIds", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(({ value }) => value === true || value === 'true'),
    __metadata("design:type", Boolean)
], InventoryOnHandFilter.prototype, "includeOutOfStock", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(({ value }) => value === true || value === 'true'),
    __metadata("design:type", Boolean)
], InventoryOnHandFilter.prototype, "includeSubCategories", void 0);
//# sourceMappingURL=inventory.js.map